import * as React from 'react';

export default React.createContext({
  loggedInUser: null,
  isLoggedIn: false,
  logout: () => {},
  login: () => {},
});
